import React from "react";
import { connect } from "react-redux";
import { Row, Col, Affix, Skeleton } from "antd";

import { interfaceActions } from "../../../../../common/redux/actions";
import * as offersActions from "../../redux/actions/offers";

import progresses from "../../../common/FormProgress/offerPregresses";
import FormOfferCard from "../../components/OfferCard/FormOfferCard";
import { getNumberWithoutSpaces } from "../../../../../common/utils/format";
import * as URLs from "../../../../../common/constants/systemUrls";
import history from "../../../../../common/history";
import OfferSideBar from "../../components/OfferCard/sidebar/SideBar";
import showConfirmWindow from "../../../../../common/components/confirmPopup/confirmPopup";
import { confirmCloseEditing } from "../../components/OfferCard/popup/confirm";
import setTemplateToForm from "../../../common/setTemplateToForm/setTemplateToForm";

import "./OfferCard.css";
import { YMaps } from "react-yandex-maps";
import Controls from "./Controls/Controls";
import { getRequest } from "../../../Request/redux/actions/requests";

const { setCaption } = interfaceActions;
const { getOffer, createOffer, updateOffer } = offersActions;

class OfferCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditable: false,
      showAllFields: false,
      formProgress: [...progresses.default]
    };
    this.forms = {};
  }

  componentDidMount() {
    this.setCaption(true);
    window.forms = this.forms;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      (!this.props.offer && !this.props.loadingOffer) ||
      this.props.match.params.id !== prevProps.match.params.id
    ) {
      this.props.getOffer(this.props.match.params.id);
    }

    if (!this.props.request && this.props.offer && !this.props.loadingRequest) {
      this.props.getRequest({ requestId: this.props.offer.requestId });
    }

    this.setCaption(this.props.offer !== prevProps.offer && this.props.offer);

    if (prevProps.updated !== this.props.updated && this.state.isEditable) {
      this.setState({ isEditable: false });
    }

    if (
      (this.props.request && this.state.ymaps !== prevState.ymaps) ||
      (!this.state.distance && this.state.duration) ||
      (this.props.request !== prevProps.request && this.state.ymaps)
    ) {
      this.renderRoute();
    }
    // Если предложение которое имеется в редаксе отличается от
    // адреса предложения, которое нас интересует, но заново запрашиваем предложение.
    if (
      this.props.offer &&
      this.props.offer.offerId !== parseInt(this.props.match.params.id) &&
      !this.props.loadingOffer
    ) {
      this.props.getOffer(this.props.match.params.id);
    }
  }

  setCaption(flagUpdate = false) {
    if (flagUpdate) {
      let title = "";
      let breadCrumbs = null;

      const { offer } = this.props;
      if (offer) {
        title =
          (offer.requestName
            ? `Предложение - ${offer.requestName} - `
            : "Предложение - ") + getNumberWithoutSpaces(offer.offerNumber);
        if (this.state.isEditable) {
          breadCrumbs = title;
          title = "Редактирование предложения";
        }
      }

      if (title) {
        this.props.setCaption({
          enabled: true,
          mainCaption: title,
          breadCrumbs: [
            {
              path: "/" + URLs.CONTROL_PANEL,
              breadcrumbName: "Панель управления"
            },
            { path: "/executorship/offer", breadcrumbName: "Исполнительство" },
            {
              path: "/" + URLs.COMPANY,
              breadcrumbName: breadCrumbs ? breadCrumbs : title
            }
          ]
        });
      }
    }
  }

  getForm = name => {
    if (this.forms.hasOwnProperty(name)) {
      return this.forms[name];
    }
    return false;
  };

  setForm = (name, form) => {
    if (form) {
      return (this.forms[name] = form);
    } else {
      delete this.forms[name];
      return false;
    }
  };

  updateProgress = values => {
    const form = this.getForm("formOfferInfo");
    if (form) {
      let newFormProgress = [...this.state.formProgress];
      let checkAll = true;
      values &&
        Object.keys(values).forEach(name => {
          this.state.formProgress.forEach((step, index) => {
            if (
              step.fields.some(fieldName => fieldName === name) &&
              step.check
            ) {
              const fieldsValue = form.getFieldsValue(step.fields);
              const check = step.check(fieldsValue, form);
              newFormProgress[index] = {
                ...newFormProgress[index],
                name: step.name,
                completed: check,
                fieldsValue: fieldsValue
              };
              if (checkAll && !check) {
                if (step.button !== false) checkAll = false;
              }
            }
          });
        });

      if (newFormProgress) {
        if (checkAll) {
          // Если все изменённые поля успешно прошли проверку
          // делаем полную проверку по всем группам
          // если button = false тогда он не участвует в проверке для кнопки отправки.
          // если в прогрессе нет ключа button то по умолчанию он равен true
          checkAll = newFormProgress.every(({ completed, button = true }) =>
            button ? completed : true
          );
        }

        this.setState({
          formProgress: newFormProgress
        });
      }
    }
  };

  handleClickEdit = () => {
    this.setCaption(true);
    this.setIsEditable(true);
  };

  handleClickClose = () => {
    history.push("/executorship/offer");
  };

  setTemplateToForm = data => {
    const form = this.getForm("formOfferInfo");
    if (form) {
      setTemplateToForm(form, data, "offer");
    }
  };

  handleSubmit = () => {
    this.formSubmit("formOfferInfo", fieldsValue => {
      this.props.updateOffer({ data: fieldsValue, ymaps: this.state.ymaps });
    });
  };

  formSubmit = (name, cbSubmit) => {
    const form = this.getForm(name);
    if (form) {
      // e.preventDefault();
      form.validateFields((err, fieldsValue) => {
        if (err) {
          return false;
        }
        // Отправка формы
        if (cbSubmit) cbSubmit(fieldsValue);
      });
    } else {
      console.log("Error", name);
    }
  };

  handleCancel = () => {
    showConfirmWindow({
      ...confirmCloseEditing,
      onOk: () => {
        this.setState({ isEditable: false });
      }
    });
  };

  initYmaps = ymaps => {
    this.setState(() => ({
      ymaps: ymaps
    }));
  };

  setIsEditable = boolean => {
    this.setState({ isEditable: boolean });
  };

  renderRoute = () => {
    const markers = this.props.request.routes.map(route => {
      return [route.latitude, route.longitude];
    });

    const multiRoute = new this.state.ymaps.multiRouter.MultiRoute(
      {
        referencePoints: markers,
        params: {
          results: 1
        }
      },
      {
        boundsAutoApply: markers.length > 1
      }
    );

    multiRoute.events.add("update", () => {
      multiRoute.getRoutes().each(route => {
        const properties = route.properties.getAll();
        this.setState(() => ({
          distance: properties.distance.text,
          duration: properties.duration.text,
          vehicleUse: properties.durationInTraffic.text
        }));
      });
    });
  };

  handleClickShowAllFields = value => {
    this.setState(state => ({ showAllFields: value }));
  };

  render() {
    const { offer, createErrors, clearError, loading } = this.props;
    const typeForm = this.state.isEditable ? "edit" : "view";
    return (
      <div
        className={"site-wrapper" + (typeForm === "view" ? " offer-card" : "")}
      >
        <Row className="offer-card__form-wrap">
          <Col span={18} className="offer-card__form">
            {loading || !offer ? (
              <Skeleton active />
            ) : (
              <FormOfferCard
                ref={el => {
                  this.componentRef = el;
                }}
                componentRef={this.componentRef}
                handleClickShowAllFields={this.handleClickShowAllFields}
                showAllFields={this.state.showAllFields}
                name="formOfferInfo"
                typeForm={typeForm}
                setForm={this.setForm}
                offer={offer}
                offerId={this.props.offer && this.props.offer.id}
                createErrors={createErrors}
                clearError={clearError}
                updateProgress={this.updateProgress}
                isEditable={this.state.isEditable}
                formProgress={this.state.formProgress}
                setIsEditable={this.setIsEditable}
                performers={this.props.performers}
              />
            )}
          </Col>
          <Col span={6} className="offer-card__status offer-card__sidebar">
            <Affix
              offsetTop={18}
              target={() => document.getElementById("mainSheet")}
            >
              <OfferSideBar
                typeForm={typeForm}
                offerId={this.props.offer && this.props.offer.offerId}
                offer={this.props.offer}
                request={this.props.request}
                handleClickEdit={this.handleClickEdit}
                handleSubmit={this.handleSubmit}
                progress={this.state.formProgress}
                handleClickClose={this.handleClickClose}
                handleCancel={this.handleCancel}
                setTemplateToForm={this.setTemplateToForm}
                distance={this.state.distance}
                duration={this.state.duration}
                vehicleUse={this.state.vehicleUse}
                {...this.props}
              />
            </Affix>
          </Col>
        </Row>
        <YMaps
          query={{
            apikey: "b6a66b8f-dc2c-4946-a916-0fb0ca680e5a"
          }}
          onApiAvaliable={ymaps => this.initYmaps(ymaps)}
        />
        {typeForm === "view" && (
          <Controls id={this.props.offer && this.props.offer.offerId} />
        )}
      </div>
    );
  }
}

export default connect(
  state => ({
    offer: state.Executorship.Offers.offers.offerById,
    request: state.Executorship.Requests.requests.requestById,
    loadingOffer: state.Executorship.Offers.offers.offersLoading,
    loadingRequest: state.Executorship.Requests.requests.loading,
    updated: state.Executorship.Offers.offers.updated,
    performers: state.Common.Filters.performers
  }),
  {
    setCaption,
    getOffer,
    createOffer,
    updateOffer,
    getRequest
  }
)(OfferCard);
